import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoprerecebimentolista(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoprerecebimentolista/FIND_OPERACAOPRERECEBIMENTOLISTA':
      case '@operacaoprerecebimentolista/UPDATE_OPERACAOPRERECEBIMENTOLISTA':
      case '@operacaoprerecebimentolista/DELETE_OPERACAOPRERECEBIMENTOLISTA':
      case '@operacaoprerecebimentolista/STORE_OPERACAOPRERECEBIMENTOLISTA':
      case '@operacaoprerecebimentolista/OPERACAOPRERECEBIMENTOLISTA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoprerecebimentolista/SUCCESS_REMOVE':
      case '@operacaoprerecebimentolista/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoprerecebimentolista/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoprerecebimentolista;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoprerecebimentolista/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoprerecebimentolista;
        break;
      }

      case '@operacaoprerecebimentolista/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
